import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-3210f235"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login-wrap"
};
const _hoisted_2 = {
  class: "holder holder-fluid"
};
const _hoisted_3 = {
  class: "login"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "title"
}, " Вход ", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Email", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "label"
}, "Пароль", -1));

const _hoisted_7 = {
  class: "pass"
};
const _hoisted_8 = ["type"];
const _hoisted_9 = {
  class: "login-line"
};
const _hoisted_10 = {
  class: "check-item"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "ch1",
  class: "check-label"
}, "Запомнить меня", -1));

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Забыли пароль? ");

const _hoisted_13 = {
  class: "register"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "Нет аккаунта?", -1));

const _hoisted_15 = /*#__PURE__*/_createTextVNode();

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Зарегистрироваться ");

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "form-button"
}, [/*#__PURE__*/_createElementVNode("button", {
  class: "button"
}, " Войти ")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => $options.handlerSubmit && $options.handlerSubmit(...args), ["prevent"]))
  }, [_createElementVNode("fieldset", null, [_hoisted_5, _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.username = $event),
    name: "email",
    type: "text",
    class: "input",
    placeholder: "Введите email"
  }, null, 512), [[_vModelText, $data.form.username]]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.password = $event),
    name: "password",
    type: $options.passwordType,
    class: "input",
    placeholder: "Введите пароль"
  }, null, 8, _hoisted_8), [[_vModelDynamic, $data.form.password]]), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    class: "show-pass",
    onClick: _cache[2] || (_cache[2] = $event => $data.hiddenPassword = !$data.hiddenPassword)
  })]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("input", {
    id: "ch1",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.rememberMe = $event),
    name: "remember",
    type: "checkbox",
    class: "check-input"
  }, null, 512), [[_vModelCheckbox, $data.form.rememberMe]]), _hoisted_11]), _createVNode(_component_router_link, {
    to: {
      name: 'recovery-password'
    },
    class: "pass-link"
  }, {
    default: _withCtx(() => [_hoisted_12]),
    _: 1
  })]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _hoisted_15, _createVNode(_component_router_link, {
    to: {
      name: 'sign-up'
    },
    class: "link"
  }, {
    default: _withCtx(() => [_hoisted_16]),
    _: 1
  })]), _hoisted_17])], 32)])])]);
}